<template>
	<div @click="saleClick">
		<van-col span="12">
			<van-card class="sales" :class="theme">
				<div slot="title" class="title" v-text="title"></div>
				<div slot="desc" class="desc" v-if="commonFormat">
					<p>共<span class="noSaled" v-text="totalNum" style="color: #1a1b1a"></span>套</p>
					<p v-if="nosaledNum > 0">待网签备案<span class="noSaled" v-text="nosaledNum" style="color: #00dd02"></span>套</p>
					<p v-if="sellNum > 0">已网签备案<span class="sell" v-text="sellNum" style="color: #dd6a62"></span>套</p>
					<p v-if="nosaleNum > 0"><span v-text="nosaleReason"></span><span class="noSale" v-text="nosaleNum" style="color: #8c8c8c"></span>套</p>
				</div>
				<div slot="desc" class="desc" v-else>
					<div v-if="specList.length==1">
						<div v-for="list in specList" :key="list.houseHold">
							<p>
								<!--{{list.houseHold}}：￥{{list.price}}/㎡-->
								<span v-text="list.houseHold"></span>：
								<span v-text="list.price" style="color: red"></span>元/㎡
							</p>
							<p>&nbsp;</p>
						</div>
					</div>
					<div v-else>
						<div v-for="list in specList" :key="list.houseHold">
							<p>
								<!--{{list.houseHold}}：￥{{list.price}}/㎡-->
								<span v-text="list.houseHold"></span>：
								<span v-text="list.price" style="color: red"></span>元/㎡
							</p>
						</div>
					</div>
				</div>
			</van-card>
		</van-col>
	</div>
</template>

<script>
	import {Card} from 'vant'

	export default {
		name: 'Sales',
		components: {
			VanCard: Card
		},
		props: {
			title: String,
			totalNum: Number,
			nosaledNum: Number,
			sellNum: Number,
			theme: String,
			nosaleNum: Number,
			nosaleReason: String,
			commonFormat: Boolean,
			specList: Array,
			rowLength: Number
		},
		data() {
			return {
				remainRow: 0
			}
		},
		mounted() {
			//计算扩展行
			let length = 1;
			if (this.nosaledNum > 0) {
				length ++
			}
			if (this.sellNum > 0) {
				length ++
			}
			if (this.nosaleNum > 0) {
				length ++
			}
			this.remainRow = this.rowLength - length
		},
		methods: {
			saleClick() {
				this.$emit("on-house-show", this.title)
			}
		}
	}
</script>

<style lang="scss">
	.van-card {
		&.sales {
			margin: 10px;
			padding: 0;
			min-width: 120px;

			.van-card__content {
				min-height: 0;
			}
			.title, .desc {
				padding: 8px;
			}
			.title {
				background-color: #ABE4FF;
				border-top-left-radius: 5px;
				border-top-right-radius: 5px;
				font-size: 14px;
				font-weight: bold;
			}
			.desc {
				background-color: #E9F8FF;
				border-bottom-left-radius: 5px;
				border-bottom-right-radius: 5px;
				font-size: 12px;
				padding-left: 8px;
				p {
					line-height: 14px;
					margin-block-start: 9px;
					margin-block-end: 9px;
					margin-inline-start: 0px;
					margin-inline-end: 0px;
				}
			}
			&.yellow {
				.title {
					background-color: #FFDFB0;
				}
				.desc {
					background-color: #FEF5E6;
				}
			}
			&.green {
				.title {
					background-color: #b0f8ff;
				}
				.desc {
					background-color: #e4fdff;
				}
			}
			&.other {
				.title {
					background-color: #acf1e2;
				}
				.desc {
					background-color: #e7fffa;
				}
			}
		}
	}
</style>
